import React from "react";
import { Accordion } from "react-bootstrap";
import "../styles/PreguntasFrecuentes.css";

export const preguntasFrecuentes = [
  {
    pregunta: "¿Qué cursos y certificaciones ofrece Fundación Nican?",
    respuesta:
      "Ofrecemos curso de auxiliar de enfermería, ciencias quirofísicas, masoterapia, diplomado en podología clínica, diplomado en quiropráctica y certificaciones laborales como EC0616, EC0076, EC0217.01, EC1375, EC0301 y EC0366.",
  },
  {
    pregunta: "¿Los cursos y certificaciones tienen validez oficial?",
    respuesta:
      "Sí. Contamos con programas de capacitación y procesos de certificación con respaldo SEP-CONOCER. Según el programa, el alumno puede consultar su certificado en los registros oficiales correspondientes.",
  },
  {
    pregunta: "¿Dónde está ubicada Fundación Nican?",
    respuesta:
      "Estamos en Ixtapaluca, Estado de México. Atendemos alumnos de Ixtapaluca, Chalco, Valle de Chalco y la zona oriente del Estado de México.",
  },
  {
    pregunta: "¿Qué requisitos necesito para inscribirme?",
    respuesta:
      "Generalmente solicitamos INE, CURP y comprobante de domicilio. Los requisitos pueden variar según el curso o certificación, por eso recomendamos contactarnos por WhatsApp para confirmar el programa de tu interés.",
  },
  {
    pregunta: "¿Hay modalidades en línea o solo cursos presenciales?",
    respuesta:
      "Los cursos de formación en áreas de salud suelen ser presenciales. Algunas alineaciones para certificaciones como EC0217.01, EC0301 y EC0366 pueden estar disponibles en modalidad virtual.",
  },
  {
    pregunta: "¿Ofrecen becas o apoyos económicos?",
    respuesta:
      "Sí. Podemos ofrecer becas de descuento mediante un estudio socioeconómico y de acuerdo con las condiciones de cada curso o certificación.",
  },
  {
    pregunta: "¿Qué beneficios tiene obtener una certificación laboral?",
    respuesta:
      "Una certificación laboral puede ayudarte a mejorar tu empleabilidad, aumentar tus ingresos, fortalecer tu perfil profesional y abrir oportunidades de autoempleo en áreas de salud, bienestar y capacitación.",
  },
  {
    pregunta: "¿Puedo trabajar mientras estudio en Fundación Nican?",
    respuesta:
      "Sí. Tenemos opciones de horarios que pueden adaptarse a personas que trabajan o que necesitan organizar su formación junto con otras responsabilidades.",
  },
  {
    pregunta: "¿Los cursos incluyen prácticas?",
    respuesta:
      "Algunos programas incluyen prácticas de campo mediante campañas de atención a población vulnerable. La disponibilidad depende del curso y del calendario vigente.",
  },
  {
    pregunta: "¿Cómo puedo recibir más información?",
    respuesta:
      "Puedes escribirnos por WhatsApp al 55 79 11 85 89. Un asesor te orientará sobre horarios, costos, requisitos y el programa que mejor se adapte a tus objetivos.",
  },
];

export default function PreguntasFrecuentes({ className = "" }) {
  return (
    <div
      id="FQA"
      className={`bg-light preguntas-frecuentes-container ${className}`}
    >
      <h2 className="text-center mb-4" data-aos="fade-up">
        Preguntas frecuentes sobre cursos y certificaciones
      </h2>
      <Accordion className="container my-4">
        {preguntasFrecuentes.map((item, index) => (
          <Accordion.Item
            eventKey={index}
            key={index}
            data-aos="fade-up"
            data-aos-delay={index * 100}
          >
            <Accordion.Header>
              <h3 className="mb-0">{item.pregunta}</h3>
            </Accordion.Header>
            <Accordion.Body>{item.respuesta}</Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </div>
  );
}
